module.exports = __webpack_public_path__ + "static/media/pw.f34a17aa.svg";